import { navigate } from "gatsby";
import { useEffect } from "react";

// "" (empty) means default culture that it's portuguese
const defaultCulture = "";

const getRedirectLanguage = () => {
  const lang = navigator?.language?.split("-")[0];
  if (!lang || lang === defaultCulture) {
    return defaultCulture;
  }

  switch (lang) {
    case "fr":
      return "fr";
    case "en":
      return "en";
    case "es":
      return "es";
    default:
      return defaultCulture;
  }
};

export default function LocalizationRedirect() {
  useEffect(() => {
    if (window.localizationRedirectApplied === true) {
      return;
    }
    window.localizationRedirectApplied = true;
    const _currentPathName = window.location.pathname.toLowerCase();

    if (
      // the default '/' is pt
      // _currentPathName.startsWith("/pt") ||
      _currentPathName.startsWith("/en") ||
      _currentPathName.startsWith("/es") ||
      _currentPathName.startsWith("/fr")
    ) {
      // lacalization already applied on URL
      return;
    }

    const urlLang = getRedirectLanguage();

    navigate(`${urlLang ? `/${urlLang}` : ""}${window.location.pathname}`, { replace: true });
  }, []);
  return null;
}
